import { Grid, Typography } from "@mui/material";

const SlideTitle = ({ children, size = 12 }) => {
  return (
    <Grid size={size} pb={2}>
      {children}
    </Grid>
  );
};

export default SlideTitle;
